import React from 'react';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
import RoleModal from 'components/RoleModal';
import { VIEW_JOB_ASSESMANT_MODAL } from './constants';
import JobAssessmentsSummary from './components/JobAssessmentsSummary';

export default function JobAssessmentsViewModal(): React.ReactElement {
    return (
        <RoleModal
            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
            param={VIEW_JOB_ASSESMANT_MODAL}
            ignoreSeason
        >
            <JobAssessmentsSummary />
        </RoleModal>
    );
}
